import { MessageBox } from "element-ui";

class MessageBoxService {
  showMessageBox(options) {
    MessageBox(options);
  }

  showConfirm(message, title, options) {
    MessageBox.prompt(message, title, options);
  }

  showPrompt(message, title, options) {
    MessageBox.prompt(message, title, options);
  }

  showAlert(message, title, options) {
    MessageBox.alert(message, title, options);
  }
}

export default MessageBoxService;
